import { createSignal } from "solid-js";

import type { AdaptiveGainState } from "./adaptiveGain";

/**
 * Last measurement from whichever microphone chain is running — the live
 * microphone in a call, or the "test microphone" chain in settings.
 *
 * A module-level signal rather than a context because the two ends are nowhere
 * near each other in the tree: the processor is built inside the voice state,
 * the meter is drawn in a settings page that may open without a call at all.
 * Only one microphone is ever processed at a time, so one slot is enough.
 */
const [micLevel, setMicLevel] = createSignal<AdaptiveGainState | null>(null);

export { micLevel };

export function publishMicLevel(state: AdaptiveGainState): void {
  setMicLevel(state);
}

/** Microphone gone — the meter must fall silent rather than freeze on the
 *  last value, which would read as "still hearing you". */
export function clearMicLevel(): void {
  setMicLevel(null);
}
